import type { Point } from '../../core/types/point.js';
import { DimensionXYPoint } from '../types/categorical-bar-chart-data.js';

const getDistance = (mousePosition: number, point: number): number =>
  mousePosition - point;

export const getClosestDistance = (
  mousePosition: Point,
  point1: DimensionXYPoint,
  point2: DimensionXYPoint,
  isVertical: boolean,
  isStacked: boolean,
): DimensionXYPoint => {
  if ((isVertical && !isStacked) || (!isVertical && isStacked)) {
    return getDistance(mousePosition.x, point1.x) <
      getDistance(mousePosition.x, point2.x)
      ? point1
      : point2;
  }

  return getDistance(mousePosition.y, point1.y) <
    getDistance(mousePosition.y, point2.y)
    ? point1
    : point2;
};
